module.exports = __webpack_public_path__ + "professional-2686f6ddddea51d44f78142d39ac88f3.png";